<template>
    <div>
        <div
            v-show="contentAssistEnabled"
            class="content-assist">
            {{ bundleName }} / {{ itemKey }}
        </div>
        <span v-html="contentToDisplay"></span>
        <template v-if="appendHtml">
            <span v-html="appendHtml"></span>
        </template>
    </div>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex';
import Vue from 'vue';

export default {
    name: 'ContentItem',
    props: {
        bundleName: {
            type: String,
            required: true
        },
        itemKey: {
            type: String,
            required: true
        },
        scrollIntoView: {
            type: Boolean,
            required: false,
            default: false
        },
        appendHtml: {
            type: String,
            required: false,
            default: ""
        }
    },
    data() {
        return { contentToDisplay: '' };
    },
    computed: {
        ...mapState('content', [
            'initialized', // -> this.initialized
            'contentAssistEnabled' // -> this.contentAssistEnabled
        ]),
        ...mapGetters('content', [
            'getContent' // -> this.getContent()
        ])
    },
    watch: {
        /**
         * Once the content store is initialized, load the content for this component
         */
        initialized() {
            this.displayContent();
        },
        bundleName() {
            this.displayContent();
        },
        itemKey() {
            this.displayContent();
        }
    },
    mounted() {
        if (!this.initialized) {
            this.initializeContent();
        } else {
            this.displayContent();
        }
    },
    methods: {
        ...mapActions('content', [
            'initializeContent' // -> this.initializeContent()
        ]),
        displayContent() {
            this.contentToDisplay = this.getContent(this.bundleName, this.itemKey);
            Vue.nextTick(() => {
                this.$emit('contentDisplayed');
            });
            if (this.scrollIntoView) {
                // break out of current thread so that DOM is updated with content,
                // then scroll to the content
                setTimeout(() => {
                    this.$el.scrollIntoView();
                }, 10);
            }
        }
    }
};
</script>

<style>
    .content-assist {
        width: auto !important;
        margin: 2px auto auto;
        background: none repeat scroll 0 0 #FFFF33;
        font-size: 10px !important;
        font-weight: bold;
        text-align: center;
    }
</style>
